export class Instruction {
  constructor ({ name, waitForNoLoaders, type }) {
    this.id = undefined
    this.type = type
    this.name = name
    this.waitForNoLoaders = waitForNoLoaders
  }

  getParsedInstruction () {
    return {
      id: this.id,
      type: this.type,
      name: this.name,
      waitForNoLoaders: this.waitForNoLoaders
    }
  }
}
